import { Component, NgZone, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, RequiredValidator, Validators } from '@angular/forms';
import { HttpService } from 'app/services/http.service';
import { validateRut, formatterRut, numberToClp } from 'chilean-formatter';
import { ConfirmationService, MessageService } from 'primeng/api';
import ExcelExport from 'export-xlsx';
import { SETTINGS_FOR_EXPORT } from '../../xlsxSettings';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit {

  usuario: any;
  clientes: any[];
  usuarios: any[];
  estaEditando: boolean = false;
  modoCreaEdita: boolean = false;
  formulario: FormGroup;

  idEmpresaSeleccionada: string;
  email: string;
  nombre: string;

  empresas: any[] = []
  empresasFiltradas: any[] = []

  passwordVisible: boolean = false;
  _tipo: string = 'USER'

  categorias: any[];
  subcategorias: any[];

  constructor(private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private http: HttpService,
    private ngZone: NgZone
  ) {

    this.usuario = JSON.parse(this.http.getLocalstorage('usuario'))

    this.categorias = [
      { tipo: 'INTERNO' },
      { tipo: 'EXTERNO' }
    ]

    this.subcategorias = [
      { tipo: 'USER' },
      { tipo: 'ADMIN' }
    ]

    this.formulario = this.formBuilder.group({
      _id: '',
      Nombre: ['', Validators.required],
      _empresa: '',
      Email: ['', Validators.required],
      TipoUsuario: ['', Validators.required],
      Password: '',
      _cliente: '',
      Categoria: ['', Validators.required],
      Subcategoria: '',
    });

    this.getClientes();
    this.getUsuarios();
    this.getEmpresas();
  }

  async ngOnInit(): Promise<void> {
    this.formulario.controls.Categoria.setValue('INTERNO')
    this.formulario.controls.Subcategoria.setValue('ADMIN')
  }

  seleccionaEmpresa(empresa) {
    console.log('event', empresa);
    this.idEmpresaSeleccionada = empresa._id
  }

  nuevo() {
    console.log('pasó por nuevo');

    this.estaEditando = false
    this.modoCreaEdita = true
    this.formulario.controls.TipoUsuario.setValue('USER')
  }

  delete(event: Event, id) {
    console.log('delete');
    console.log('id', id);
    this.confirmationService.confirm({
      target: event.target,
      message: 'Está seguro?',
      icon: 'pi pi-exclamation-triangle',
      rejectLabel: 'No',
      acceptLabel: 'Si, eliminar',
      accept: () => {
        this.http.deleteUsuarioService(id)
          .subscribe((data: any) => {
            console.log(data);
            this.getUsuarios();
          })
        this.messageService.add({
          severity: "info",
          summary: "Listo",
          detail: "El usuario ha sido eliminado"
        });
      },
      reject: () => {
        return;
      }
    });

  }

  async getEmpresas(): Promise<void> {
    console.log('getEmpresas');

    this.empresas = await this.http.getEmpresaService();

    this.ngZone.run(() => { })
  }

  searchEmpresa(event) {
    var filtered: any[] = [];
    var query = event.query;
    for (let i = 0; i < this.empresas.length; i++) {
      let param = this.empresas[i];
      if (param.NombreEmpresa.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
        filtered.push(param);
      }
    }
    this.empresasFiltradas = filtered;
    console.log('this.empresasFiltradas', this.empresasFiltradas);

  }

  cambiaTipoUsuario() {
    console.log('cambiaTipoUsuario');
    console.log(this._tipo);
    if (this._tipo == 'ADMIN') {
      this.formulario.controls._cliente.setValue(null)
      this.formulario.controls._cliente.clearValidators()
      this.formulario.controls.TipoUsuario.setValue('ADMIN')
    } else {
      this.formulario.controls._cliente.setValidators([Validators.required])
      this.formulario.controls.TipoUsuario.setValue('USER')
    }
    this.formulario.controls._cliente.updateValueAndValidity()
  }

  guardar(_formValue) {

    let formValue = JSON.parse(JSON.stringify(_formValue))
    formValue.Empresa = formValue._empresa._id

    formValue.Email = formValue.Email.trim()
    formValue.Nombre = formValue.Nombre.trim()

    // Desde ADMIN sólo se pueden crear usuarios INTERNO ADMIN
    formValue.Categoria = 'INTERNO'
    formValue.Subategoria = 'ADMIN'

    console.log('formValue', formValue);



    if (this.estaEditando) {

      this.http.updateUsuarioService(formValue).subscribe((data: any) => {
        console.log('data', data);
        this.getUsuarios()
        this.messageService.add({
          severity: 'success',
          summary: 'Listo!',
          detail: 'El usuario fue actualizado correctamente'
        });

        this.modoCreaEdita = false;
        this.estaEditando = false;

        this.limpiaFormulario()
      }, err => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: err.error
        });
      })

      return;
    }

    this.http.newUsuarioService(formValue).subscribe((data: any) => {
      console.log('data', data);
      this.getUsuarios()
      this.messageService.add({
        severity: 'success',
        summary: 'Listo!',
        detail: 'El usuario fue creado correctamente'
      });

      this.modoCreaEdita = false;
      this.limpiaFormulario()
    }, err => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error!',
        detail: err.error
      });
    })

  }

  async getClientes(): Promise<void> {
    this.clientes = await this.http.getclientesbyEmpresaService(this.usuario.Empresa._id);
    console.log('clientes', this.clientes);
  }

  async getUsuarios(): Promise<void> {
    this.usuarios = await this.http.getAllUsuariosService();
    console.log('usuarios', this.usuarios);

    this.ngZone.run(() => { })
  }

  formateaRUT() {
    this.formulario.controls.RutCliente.setValue(formatterRut(this.formulario.controls.RutCliente.value))

    if (!validateRut(this.formulario.controls.RutCliente.value))
      this.formulario.controls.RutCliente.setErrors({ 'incorrect': true })
  }

  abreModaledita(id) {
    console.log('id:', id);

    this.estaEditando = true
    this.modoCreaEdita = true
    let index = this.usuarios.findIndex(e => e._id == id)

    let usuario = this.usuarios[index]
    let categoria = usuario.Categoria

    if (this._tipo == 'SUPER')
      this._tipo = 'ADMIN'

    if (usuario.Empresa)
      usuario._empresa = usuario.Empresa

    console.log('usuario', usuario);

    this.formulario.patchValue(usuario)

    // if (usuario.TipoUsuario == 'USER') {
    //   let _cliente = this.clientes.find(e => e._id == usuario.Cliente)
    //   this.formulario.controls._cliente.setValue(_cliente._id)
    // }

  }

  descargar(internos: boolean) {
    console.log('descargar');
    const excelExport = new ExcelExport();

    let usuarios = this.usuarios
    if (internos) {
      usuarios = this.usuarios.filter(e => e.Categoria == 'INTERNO')
    }
    usuarios = usuarios.map(e => {
      return {
        'Nombre': e.Nombre,
        'Email': e.Email,
        'Empresa': e.Empresa.NombreEmpresa,
        'Pais': e.Empresa.Pais,
        'Categoria': e.Categoria,
        'Subcategoria': e.Subcategoria,
        'createdAt': new Date(e.createdAt).toLocaleString(),
        'updatedAt': new Date(e.updatedAt).toLocaleString(),

      }
    })

    let data = [{ data: usuarios }]
    console.log('SETTINGS_FOR_EXPORT', SETTINGS_FOR_EXPORT);
    let now = new Date()
    let d = now.getDate()
    let M = now.getMonth() + 1
    let y = now.getFullYear()
    let h = now.getHours()
    let m = now.getMinutes()
    let filename = 'Usuarios_' + d.toString() + M.toString() + y.toString() + '_' + h.toString() + m.toString()
    SETTINGS_FOR_EXPORT.fileName = filename

    SETTINGS_FOR_EXPORT.workSheets[0].sheetName = 'Usuarios'

    let def = [
      {
        name: 'Nombre',
        key: 'Nombre',
        width: 40,
      },
      {
        name: 'Email',
        key: 'Email',
        width: 30,
      },
      {
        name: 'Empresa',
        key: 'Empresa',
        width: 30,
      },
      {
        name: 'Pais',
        key: 'Pais',
        width: 20,
      },
      {
        name: 'Categoria',
        key: 'Categoria',
        width: 15,
      },
      {
        name: 'Subcategoria',
        key: 'Subcategoria',
        width: 15,
      },
      {
        name: 'Creado',
        key: 'createdAt',
        width: 20,
      },
      {
        name: 'Actualizado',
        key: 'updatedAt',
        width: 20,
      }
    ]

    SETTINGS_FOR_EXPORT.workSheets[0].tableSettings.data.headerDefinition = def
    excelExport.downloadExcel(SETTINGS_FOR_EXPORT, data);

  }

  limpiaFormulario() {
    this.formulario.reset()
    this.modoCreaEdita = false
    this.estaEditando = false
    this.passwordVisible = false
  }

}
